import React from "react";

export const InkleAdminBooks = () => {
  return (
    <svg
      width="189"
      height="56"
      viewBox="0 0 189 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.1042 29.4111H26.569C26.5125 29.4111 26.525 29.5257 26.7036 29.6172C26.8464 29.6905 26.8668 29.9459 26.8591 30.0644V37.9999H30.1268V30.153C30.007 29.6227 29.0682 29.4375 28.6137 29.4111H28.1042Z"
        fill="url(#paint0_linear_5723_7950)"
      />
      <path
        d="M22.7898 26.5635H21.2545C21.198 26.5635 21.2106 26.716 21.3891 26.8379C21.532 26.9355 21.5523 27.2756 21.5446 27.4335V38.0006H24.8124V27.5514C24.6925 26.8452 23.7537 26.5986 23.2993 26.5635H22.7898Z"
        fill="url(#paint1_linear_5723_7950)"
      />
      <path
        d="M17.5652 23.334H16.0299C15.9734 23.334 15.9859 23.529 16.1645 23.685C16.3074 23.8097 16.3277 24.2446 16.32 24.4465V37.9596H19.5877V24.5973C19.4679 23.6943 18.5291 23.3788 18.0747 23.334H17.5652Z"
        fill="url(#paint2_linear_5723_7950)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.4285 20.8513H16V18H27.4285C28.8476 18 30.9444 18.4131 32.7275 19.6943C34.5835 21.0279 35.9999 23.2379 35.9999 26.5539V37.959H33.1428V26.5539C33.1428 24.1672 32.1783 22.8132 31.0581 22.0083C29.865 21.151 28.3904 20.8513 27.4285 20.8513Z"
        fill="url(#paint3_linear_5723_7950)"
      />
      <path
        d="M46 20.065C46 18.8121 46.78 18 48.0058 18C49.2092 18 49.9893 18.8121 49.9893 20.065C49.9893 21.3179 49.2092 22.1531 48.0058 22.1531C46.78 22.1531 46 21.3179 46 20.065ZM49.7887 37.8839H46.2229V23.9629H49.7887V37.8839Z"
        fill="url(#paint4_linear_5723_7950)"
      />
      <path
        d="M60.7289 30.9002C60.7289 28.8584 59.7037 27.5127 58.1214 27.5127C56.6282 27.5127 55.5362 28.9512 55.5362 30.9234V37.8839H51.9703V23.9629H55.5362V25.587C56.0042 24.5429 57.3859 23.8004 58.7677 23.8004C62.1775 23.8004 64.2947 26.6311 64.2947 30.9002V37.8839H60.7289V30.9002Z"
        fill="url(#paint5_linear_5723_7950)"
      />
      <path
        d="M70.0118 37.8839H66.446V18.1624H70.0118V30.2041L74.5359 23.9629H78.4361L73.8896 30.9234L78.9041 37.8839H74.3799L70.0118 31.6426V37.8839Z"
        fill="url(#paint6_linear_5723_7950)"
      />
      <path
        d="M83.8047 37.8839H80.2389V18.1624H83.8047V37.8839Z"
        fill="url(#paint7_linear_5723_7950)"
      />
      <path
        d="M94.646 33.6148H98.4346C97.5209 36.2134 95.1363 37.9999 92.4173 37.9999C88.5172 37.9999 85.776 35.0533 85.776 30.877C85.776 26.8399 88.6064 23.7772 92.3505 23.7772C96.0946 23.7772 98.9249 26.8399 98.9249 30.877C98.9249 31.3178 98.9026 31.7819 98.8358 32.1995H89.5201C89.9213 33.6148 91.0133 34.5197 92.395 34.5197C93.4425 34.5197 94.2671 34.1484 94.646 33.6148ZM89.5201 29.5313H95.1808C94.7797 28.1624 93.7322 27.2807 92.3505 27.2807C90.9687 27.2807 89.9213 28.1624 89.5201 29.5313Z"
        fill="url(#paint8_linear_5723_7950)"
      />
      <path
        d="M169.853 31.7402C169.853 29.2731 168.589 27.6827 166.632 27.6827C164.817 27.6827 163.512 29.3954 163.512 31.7606V37.8775H161.31V25.6437H163.512V27.9273C163.981 26.5205 165.368 25.501 166.999 25.501C170.098 25.501 172.055 27.9681 172.055 31.7402V37.8775H169.853V31.7402Z"
        fill="#41395C"
      />
      <path
        d="M156.732 21.9739C156.732 21.1991 157.242 20.6689 158.058 20.6689C158.833 20.6689 159.342 21.1991 159.342 21.9739C159.342 22.7691 158.833 23.2992 158.058 23.2992C157.242 23.2992 156.732 22.7691 156.732 21.9739ZM159.159 37.8778H156.957V25.644H159.159V37.8778Z"
        fill="#41395C"
      />
      <path
        d="M144.074 31.7402C144.074 29.2731 142.81 27.6827 140.852 27.6827C139.038 27.6827 137.733 29.3954 137.733 31.7606V37.8775H135.531V25.6437H137.733V27.9273C138.202 26.5205 139.588 25.501 141.219 25.501C143.177 25.501 144.686 26.5001 145.522 28.172C146.317 26.4797 147.703 25.501 149.457 25.501C152.74 25.501 154.819 27.9681 154.819 31.7402V37.8775H152.617V31.7402C152.617 29.2731 151.353 27.6827 149.375 27.6827C147.581 27.6827 146.276 29.3954 146.276 31.7402V37.8775H144.074V31.7402Z"
        fill="#41395C"
      />
      <path
        d="M131.167 37.878V35.5944C130.617 37.0217 128.884 38.0004 127.049 38.0004C123.521 38.0004 121.197 35.5129 121.197 31.7408C121.197 27.9891 123.521 25.5016 127.049 25.5016C128.843 25.5016 130.617 26.4803 131.167 27.9279V20.5469H133.369V37.878H131.167ZM123.399 31.7408C123.399 34.1875 125.01 35.7983 127.293 35.7983C129.597 35.7983 131.188 34.1875 131.167 31.7612C131.167 29.3552 129.536 27.6832 127.293 27.6832C124.989 27.6832 123.399 29.294 123.399 31.7408Z"
        fill="#41395C"
      />
      <path
        d="M103.925 37.8781L110.939 20.5469H113.284L120.298 37.8781H117.953L116.097 33.3108H108.125L106.27 37.8781H103.925ZM108.981 31.1699H115.241L112.121 23.4422L108.981 31.1699Z"
        fill="#41395C"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5723_7950"
          x1="26.5391"
          y1="33.7055"
          x2="30.1268"
          y2="33.7055"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5723_7950"
          x1="21.2246"
          y1="32.282"
          x2="24.8124"
          y2="32.282"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5723_7950"
          x1="16"
          y1="30.6468"
          x2="19.5878"
          y2="30.6468"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5723_7950"
          x1="16"
          y1="27.9795"
          x2="35.9999"
          y2="27.9795"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_5723_7950"
          x1="46"
          y1="28"
          x2="98.9249"
          y2="28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_5723_7950"
          x1="46"
          y1="28"
          x2="98.9249"
          y2="28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_5723_7950"
          x1="46"
          y1="28"
          x2="98.9249"
          y2="28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_5723_7950"
          x1="46"
          y1="28"
          x2="98.9249"
          y2="28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_5723_7950"
          x1="46"
          y1="28"
          x2="98.9249"
          y2="28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8B08FD" />
          <stop offset="1" stopColor="#5622FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
